import styled from 'styled-components';
import { theme } from '../../style/theme';
import { mixins } from '../../style/mixins';
import { device } from '../../style/device';
import { Section } from '../../style/section';

const { colors } = theme;




export const StyledContainer = styled(Section)`
    position: realtive;
`;

export const StyledFlexContainer = styled.div`
    ${mixins.flexBetween};
    align-items: flex-start;
    ${device.tablet`display: block;`};
`;

export const StyledContent = styled.div`
  width: 60%;
  padding: 20px;
  max-width: 480px;
  color: white;
  ${device.tablet`width: 100%;`};
  a {
    ${mixins.inlineLink};
  }
  text-align: left;
`;

export const StyledAvatar = styled.img`
  position: relative;
  width:300px;
  height:350px;
  border-radius: ${theme.borderRadius};
  transition: ${theme.transition};
 
`;

export const StyledPic = styled.div`
  ${mixins.boxShadow}
  position: relative;
  max-width: 300px;
  background-color: rgba(217,1,255,0.8);
  ${device.tablet`margin: 60px auto 0;`};
  ${device.phablet`width: 70%;`};
  width: 100%;
  border-radius: ${theme.borderRadius};
  background-color: ${colors.primary};
  margin-left: -20px;
  &:hover,
  &:focus {
    background: transparent;
    &:after {
      top: 15px;
      left: 15px;
    }
    ${StyledAvatar} {
      filter: none;
      mix-blend-mode: normal;
    }
  }
  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: ${theme.borderRadius};
    transition: ${theme.transition};
  }
  &:before {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${colors.navy};
    mix-blend-mode: screen;
  }
  &:after {
    border: 3px solid ${colors.primary};
    top: 20px;
    left: 20px;
    z-index: -1;
  } 
`;